import { QueryClient } from '@tanstack/react-query';

import { ApiError, NetworkError } from '../api/api-client.js';

const CLIENT_ERROR_FLOOR = 400;
const SERVER_ERROR_FLOOR = 500;
const MAX_RETRIES = 2;
const STALE_TIME_MS = 30_000;

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (error instanceof NetworkError) return true;
  if (error instanceof ApiError) {
    return error.status >= SERVER_ERROR_FLOOR || error.status < CLIENT_ERROR_FLOOR;
  }
  return false;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: STALE_TIME_MS,
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
